import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { fetchNewsDetail, deleteNews } from 'actions/News'
import NewsView from 'components/pages/news/Detail'
import history from 'utils/history'
import Browser from 'utils/Browser'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchNewsDetail: bindActionCreators(fetchNewsDetail, dispatch),
  deleteNews: bindActionCreators(deleteNews, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {
    detail: {},
    isFetching: true,
  }),
  withHandlers({
    getDetail: props => async (id) => {
      const { setData } = props
      props.fetchNewsDetail(id)
        .then((res) => {
          setData({
            detail: res,
            isFetching: false,
          })
        })
        .catch(() => {
          setData({
            detail: {},
            isFetching: false,
          })
        })
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading } = props
      setIsLoading(true)

      try {
        const res = await props.deleteNews(id)
        message.success(res)
        setIsLoading(false)
        Browser.setWindowHref('/news')
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Detail Berita',
        activePage: 'news',
        activeSubPage: 'news',
      })

      this.props.getDetail(this.props.match.params.id)
    },
  }),
)(NewsView)
